export const bonsecours = {
  logo_image_url: 'bonsecours.png',
  logo_height: 108,

  button_color: '#009bd6',

  text_font: `'Lato', sans-serif;`,
  text_color: 'black',
  title_font: `'Lato', sans-serif;`,
}

export const expotempo2026fr = {
  logo_hidden: true,
  token_hidden: true,
  number_hidden: true,

  title_centered: false,
  title_margin_left: 10,

  button_color: '#000000',
  button_text_color: '#FFFFFF',
  button_border_width: 3,
  button_no_border: false,
  button_border_color: '#000000',

  button_outlined_color: '#FFFFFF',
  button_outlined_text_color: '#000000',
  button_outlined_hover_color: '#000000',
  button_outlined_hover_border_color: '#000000',

  title_font: 'Poppins',
  text_font: 'Poppins',

  header_hidden: true,

  body_background_color: '#FFFFFF',

  footer_img_top: 'bonsecours/bonsecours.png',

  footer_border_hidden: true,
  footer_img_top_width: 240,
  footer_background_color: '#FFFFFF',
}

export const expotempo2026en = {
  logo_hidden: true,
  token_hidden: true,
  number_hidden: true,

  title_italic: true,
  title_centered: false,
  title_margin_left: 10,
  subtitle_italic: true,
  text_italic: true,

  button_color: '#000000',
  button_text_color: '#FFFFFF',
  button_border_width: 3,
  button_no_border: false,
  button_border_color: '#000000',

  button_outlined_color: '#FFFFFF',
  button_outlined_text_color: '#000000',
  button_outlined_hover_color: '#000000',
  button_outlined_hover_border_color: '#000000',

  title_font: 'Poppins',
  text_font: 'Poppins',

  header_hidden: true,

  body_background_color: '#FFFFFF',

  footer_img_top: 'bonsecours/bonsecours.png',

  footer_border_hidden: true,
  footer_img_top_width: 240,
  footer_background_color: '#FFFFFF',
}

//beige #A39B87

export const expotempo2026zone2fr = {
  logo_hidden: true,
  token_hidden: true,
  number_hidden: true,

  title_centered: false,
  title_margin_left: 10,

  button_color: '#000000',
  button_text_color: '#A39B87',
  button_border_width: 3,
  button_no_border: false,
  button_border_color: '#000000',

  button_outlined_color: '#FFFFFF',
  button_outlined_text_color: '#000000',
  button_outlined_hover_color: '#000000',
  button_outlined_hover_border_color: '#000000',

  title_font: 'Poppins',
  text_font: 'Poppins',

  header_hidden: true,

  body_background_color: '#A39B87',

  card_background_color: '#A39B87',

  footer_img_top: 'bonsecours/bonsecours2.png',

  footer_border_hidden: true,
  footer_img_top_width: 240,
  footer_background_color: '#A39B87',
}

export const expotempo2026zone2en = {
  logo_hidden: true,
  token_hidden: true,
  number_hidden: true,

  title_italic: true,
  title_centered: false,
  title_margin_left: 10,
  subtitle_italic: true,
  text_italic: true,

  button_color: '#000000',
  button_text_color: '#A39B87',
  button_border_width: 3,
  button_no_border: false,
  button_border_color: '#000000',

  button_outlined_color: '#FFFFFF',
  button_outlined_text_color: '#000000',
  button_outlined_hover_color: '#000000',
  button_outlined_hover_border_color: '#000000',

  title_font: 'Poppins',
  text_font: 'Poppins',

  header_hidden: true,

  body_background_color: '#A39B87',

  card_background_color: '#A39B87',

  footer_img_top: 'bonsecours/bonsecours2.png',

  footer_border_hidden: true,
  footer_img_top_width: 240,
  footer_background_color: '#A39B87',
}

export const expotempo2026zone3fr = {
  logo_hidden: true,
  token_hidden: true,
  number_hidden: true,

  title_centered: false,
  title_margin_left: 10,

  button_color: '#FFFFFF',
  button_text_color: '#000000',
  button_border_width: 3,
  button_no_border: false,
  button_border_color: '#FFFFFF',

  button_outlined_color: '#FFFFFF',
  button_outlined_text_color: '#000000',
  button_outlined_hover_color: '#000000',
  button_outlined_hover_border_color: '#000000',

  title_font: 'Poppins',
  text_font: 'Poppins',
  text_color: '#FFFFFF',

  header_hidden: true,

  body_background_color: '#000000',

  card_background_color: '#000000',

  footer_text_color: '#FFFFFF',

  footer_img_top: 'bonsecours/bonsecours3.png',

  footer_border_hidden: true,
  footer_img_top_width: 240,
  footer_background_color: '#000000',
}

export const expotempo2026zone3en = {
  logo_hidden: true,
  token_hidden: true,
  number_hidden: true,

  title_italic: true,
  title_centered: false,
  title_margin_left: 10,
  subtitle_italic: true,
  text_italic: true,

  button_color: '#FFFFFF',
  button_text_color: '#000000',
  button_border_width: 3,
  button_no_border: false,
  button_border_color: '#FFFFFF',

  button_outlined_color: '#FFFFFF',
  button_outlined_text_color: '#000000',
  button_outlined_hover_color: '#000000',
  button_outlined_hover_border_color: '#000000',

  title_font: 'Poppins',
  text_font: 'Poppins',
  text_color: '#FFFFFF',

  header_hidden: true,

  body_background_color: '#000000',

  card_background_color: '#000000',

  footer_text_color: '#FFFFFF',

  footer_img_top: 'bonsecours/bonsecours3.png',

  footer_border_hidden: true,
  footer_img_top_width: 240,
  footer_background_color: '#000000',
}

//tod validate font
